/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Slug_PlaceholderInputs */

const en_admin_posts_slug_placeholder = /** @type {(inputs: Admin_Posts_Slug_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. my-first-post`)
};

/**
* | output |
* | --- |
* | "e.g. my-first-post" |
*
* @param {Admin_Posts_Slug_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_posts_slug_placeholder = /** @type {((inputs?: Admin_Posts_Slug_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Slug_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_posts_slug_placeholder(inputs)
});
export { admin_posts_slug_placeholder as "admin.posts.slug_placeholder" }